// 接口基本地址
// export const API_URI = 'http://192.168.1.16:8222/api'; // 15测试
// export const API_URI = 'http://192.168.1.147:8080/api'; // 赵磊本机
// export const API_URI = 'http://192.168.1.39:8083/api'; // 许伦杰本机
export const API_URI = 'https://www.adamroi.com/api'; // 正式环境
export const EXPORT_FILE_URI = `https://www.adamroi.com/static/`;
export const CREATIVE_URI = `http://creative.adamroi.com/`;

// 公用配置项
export const options = {
  inputIconPrefixStyle: {
    fontSize: "16px",
    color: "#2290FF"
  },
  channelList: ["全部", "Facebook", "Google"]
};

// Facebook权限列表
export const FB_PERMISSIONS = {
  // 基本权限
  basic: 'ads_read,email,ads_management,manage_pages,public_profile,read_insights',
  // 用户权限
  user: 'email,user_hometown,user_likes,user_status,user_location,user_tagged_places,user_birthday,user_photos,user_videos,user_posts,user_friends,publish_video,user_age_range,user_gender,user_link',
  // 活动、小组、主页权限
  aghp: 'ads_management,pages_messaging,read_page_mailboxes,ads_read,business_management,pages_messaging_phone_number,user_events,manage_pages,pages_messaging_subscriptions,pages_manage_cta,pages_show_list,pages_manage_instant_articles,publish_pages',
  // 其他权限
  other: 'instagram_basic,instagram_manage_insights,read_insights,instagram_manage_comments,leads_retrieval,groups_access_member_info,publish_to_groups',
  all: function () {
    return 'ads_management,ads_read,manage_pages,business_management,email'
    // return [this.basic, this.user, this.aghp, this.other].join(',');
  }
};
